import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';
import { Language } from '../i18n';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage, isToggleEnabled } = useLanguage();

  if (!isToggleEnabled) {
    return null;
  }

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newLanguage: Language | null
  ) => {
    if (newLanguage) {
      setLanguage(newLanguage);
    }
  };

  return (
    <ToggleButtonGroup
      value={language}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label="language"
      sx={{
        '& .MuiToggleButton-root': {
          color: 'inherit',
          borderColor: 'rgba(255,255,255,0.5)',
          px: 1,
          py: 0.25,
          fontWeight: 600,
          '&.Mui-selected': {
            color: 'inherit',
            backgroundColor: 'rgba(255,255,255,0.25)',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.35)',
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        },
      }}
    >
      <ToggleButton value="en">EN</ToggleButton>
      <ToggleButton value="es">ES</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LanguageToggle;
